// extracted by mini-css-extract-plugin
module.exports = {"content":"PageBlock_content__Nijia"};